
/*=========================================================================================
  File Name: modulekaindsGetters.js
  Description: kainds Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/
export default {
  getListStatus: state => state.listStatus
}
